var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_341_14566",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_341_14566)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V9.33333H12.4444L13.3333 10L0 20Z",
    fill: "#DD1C34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 9.33333H12.4444L0 0H28V9.33333Z",
    fill: "#0D4BC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99999 4.00001C2.36818 4.00001 2.66666 3.70153 2.66666 3.33334C2.66666 2.96515 2.36818 2.66667 1.99999 2.66667C1.63181 2.66667 1.33333 2.96515 1.33333 3.33334C1.33333 3.70153 1.63181 4.00001 1.99999 4.00001ZM10 10.6667C10.3682 10.6667 10.6667 10.3682 10.6667 10C10.6667 9.63181 10.3682 9.33334 10 9.33334C9.63181 9.33334 9.33333 9.63181 9.33333 10C9.33333 10.3682 9.63181 10.6667 10 10.6667ZM2.66666 16.6667C2.66666 17.0349 2.36818 17.3333 1.99999 17.3333C1.63181 17.3333 1.33333 17.0349 1.33333 16.6667C1.33333 16.2985 1.63181 16 1.99999 16C2.36818 16 2.66666 16.2985 2.66666 16.6667ZM4.53207 11.3266L3.39105 13.0796L3.82378 11.0332C3.75415 10.9763 3.69037 10.9125 3.63349 10.8429L1.58706 11.2756L3.34004 10.1346C3.3356 10.0903 3.33333 10.0454 3.33333 10C3.33333 9.95458 3.3356 9.90968 3.34004 9.86541L1.58706 8.72439L3.63349 9.15712C3.69037 9.08749 3.75415 9.02371 3.82378 8.96684L3.39105 6.92041L4.53207 8.67338C4.57633 8.66894 4.62123 8.66667 4.66666 8.66667C4.71209 8.66667 4.75699 8.66894 4.80125 8.67338L5.94227 6.92041L5.50954 8.96684C5.57918 9.02371 5.64295 9.08749 5.69983 9.15712L7.74626 8.72439L5.99329 9.86541C5.99772 9.90967 6 9.95457 6 10C6 10.0454 5.99772 10.0903 5.99329 10.1346L7.74626 11.2756L5.69983 10.8429C5.64295 10.9125 5.57918 10.9763 5.50954 11.0332L5.94227 13.0796L4.80125 11.3266C4.75699 11.3311 4.71209 11.3333 4.66666 11.3333C4.62123 11.3333 4.57633 11.3311 4.53207 11.3266Z",
    fill: "#FDD64D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/PH.7cfed480.svg";
export { ForwardRef as ReactComponent };